export default __webpack_public_path__ + "static/icon-22-6-b2f7eb8bf3663b13695112530721478c.png";